module.exports = __webpack_public_path__ + "static/media/WordMark_ai.46c01840.zip";